/* @flow */

export default class CheckDebtorTokenRequest {
  token: string;

  constructor(token: string) {
    this.token = token;
  }
}
